import type { CatalogueViewerGate } from "../../types/catalogue.types";

export const VIEWER_GATE_OPTIONS: { value: CatalogueViewerGate; title: string; detail: string }[] = [
  { value: "NONE", title: "Just open", detail: "Anyone with the link browses straight away." },
  { value: "NAME", title: "Ask their name", detail: "Mobile optional. You see who opened it." },
  { value: "PHONE", title: "Name and mobile", detail: "Both required, no code." },
  {
    value: "OTP",
    title: "Name, mobile and OTP",
    detail: "Indian mobiles get an SMS code. Other countries are recorded without one.",
  },
];

export const VIEWER_GATE_SHORT: Record<CatalogueViewerGate, string> = {
  NONE: "opens without a code",
  NAME: "asks their name",
  PHONE: "asks name and mobile",
  OTP: "asks name, mobile and OTP",
};

/**
 * True when the buyer page must show the gate form before opening. The studio that owns the
 * catalogue is never asked: public-status gets its JWT and answers NONE for it. Any other signed-in
 * studio is a viewer like everyone else.
 */
export function viewerGateNeeded(gate: string | undefined | null): boolean {
  return gate === "NAME" || gate === "PHONE" || gate === "OTP";
}

/** Shown when a link fails to open. Group links are often opened inside WhatsApp, which has no incognito. */
export const OPEN_LINK_RETRY_HINT =
  "Not opening? Open the link in Chrome or Safari, or in an incognito window.";

export function viewerGateRequiresPhone(gate: string | undefined | null): boolean {
  return gate === "PHONE" || gate === "OTP";
}
